import React from "react";

const DiamondEllipse = ({
  width = 53,
  height = 52,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 53 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="52" r="52" fill="#5E6473" />
    </svg>
  );
};

export default DiamondEllipse;
